export default function Check() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        className="circle"
        d="M11 20.353C9.70278 20.353 8.4856 20.1076 7.34847 19.6169C6.21119 19.1262 5.22196 18.4603 4.38076 17.6193C3.53972 16.7781 2.87384 15.7888 2.38312 14.6516C1.89239 13.5144 1.64703 12.2972 1.64703 11C1.64703 9.70278 1.89239 8.4856 2.38312 7.34847C2.87384 6.21119 3.53972 5.22196 4.38076 4.38076C5.22196 3.53972 6.21119 2.87384 7.34847 2.38312C8.4856 1.89239 9.70278 1.64703 11 1.64703C12.2972 1.64703 13.5144 1.89239 14.6516 2.38312C15.7888 2.87384 16.7781 3.53972 17.6193 4.38076C18.4603 5.22196 19.1262 6.21119 19.6169 7.34847C20.1076 8.4856 20.353 9.70278 20.353 11C20.353 12.2972 20.1076 13.5144 19.6169 14.6516C19.1262 15.7888 18.4603 16.7781 17.6193 17.6193C16.7781 18.4603 15.7888 19.1262 14.6516 19.6169C13.5144 20.1076 12.2972 20.353 11 20.353Z"
        fill="#0A0A60"
      />
      <path
        className="tick"
        d="M9.70018 15.3262L16.2449 8.78168L14.8136 7.3448L9.70018 12.4582L7.15345 9.91147L5.7223 11.3483L9.70018 15.3262Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
